import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { FileServiceService } from '../service/file-service.service';
import { FileCaptureService } from 'app/service/file-capture.service';

@Component({
  standalone: false,
  selector: 'app-referance',
  templateUrl: './referance.component.html',
  styleUrls: ['./referance.component.css']
})
export class ReferanceComponent implements OnInit {
  
  buttonText: string = 'Proceed to Email Address Verification';
  authCode = '';
  referenceForm: FormGroup = new FormGroup({
    businessName: new FormControl('', [Validators.required, Validators.maxLength(60)]),
    contactName: new FormControl('', [Validators.required, Validators.maxLength(60)]),
    contactPhone: new FormControl('',[Validators.required, Validators.maxLength(60)]),
    contactEmail: new FormControl('', [Validators.required, Validators.maxLength(60), Validators.email, this.customEmailValidator  ])
  });

  isInvalidEmail: boolean = false;

  constructor(private route: Router, public service: FileServiceService,  public fileService: FileCaptureService) {
  }

  ngOnInit() {
    this.service.setPageVisited('reference');
    this.referenceForm.get('businessName')?.setValue(this.service.getCache("businessName"));
    this.referenceForm.get('contactName')?.setValue(this.service.getCache("contactName"));
    this.referenceForm.get('contactPhone')?.setValue(this.service.getCache("contactPhone"));
    this.referenceForm.get('contactEmail')?.setValue(this.service.getCache("contactEmail"));
    this.service.referenceFileDetails.referenceId = this.service.getCache("referenceId");

    const email = this.referenceForm.get('contactEmail')?.value;
    if (this.service.isEmailAuthenticated(email)) {
      this.buttonText = 'Proceed to Next Section';
    }

    this.referenceForm.get('contactEmail')?.valueChanges.subscribe((newEmail) => {
      if (newEmail && this.service.isEmailAuthenticated(newEmail)) {
        this.buttonText = 'Proceed to Next Section';
      } else {
        this.service.setAuthenticatedEmail(null);
        this.service.clearVisitedPages();
        this.buttonText = 'Proceed to Email Address Verification';
      }
    });
  }

  customEmailValidator(control: FormControl): { [key: string]: boolean } | null {
    const email = control.value;
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    if (email && !emailRegex.test(email)) {
      return { invalidEmailFormat: true };
    }
    return null;
  }

    onKeyUpEmailFormatEvent(event: any) {
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    if (event) {
      event.srcElement.value && !emailRegex.test(event.srcElement.value)
        ? (this.isInvalidEmail = true)
        : (this.isInvalidEmail = false);
    }
  }

  next() {
    if (this.referenceForm.invalid) {
      return;
    }

    const email = this.referenceForm.get('contactEmail')?.value;
    const isAuthenticated = this.service.isEmailAuthenticated(email);

    this.service.referenceFileDetails.businessName = this.referenceForm.get('businessName')?.value;
    this.service.referenceFileDetails.contactName = this.referenceForm.get('contactName')?.value;
    this.service.referenceFileDetails.contactPhone = this.referenceForm.get('contactPhone')?.value;
    this.service.referenceFileDetails.contactEmail = email;

    const cacheItems = [
      { id: "businessName", value: this.service.referenceFileDetails.businessName },
      { id: "contactName", value: this.service.referenceFileDetails.contactName },
      { id: "contactPhone", value: this.service.referenceFileDetails.contactPhone },
      { id: "referenceId", value: this.service.getCache('referenceId') }
    ];

    if (email) {
      cacheItems.push({ id: "contactEmail", value: email });
    }

    this.service.setCacheForitems(cacheItems);

    if (isAuthenticated) {
      this.route.navigate(['file-upload']);
    } else {
      this.generateUniqueCode();
      this.route.navigate(['email-auth']);
    }
  }

  close() {
    const sessionId = window.sessionStorage.getItem(this.fileService.SESSION_KEY) || '';
    const payorKey = Number(window.sessionStorage.getItem(this.fileService.PAYOR_KEY) || 0);
    const referenceId = this.service.referenceFileDetails.referenceId || this.service.getCache('referenceId');

    this.fileService.releaseActiveReferenceLock(payorKey, referenceId, sessionId).subscribe();

    this.service.referenceFileDetails.referenceId = "";
    this.service.clearCache();
    let url = window.localStorage.getItem('securityCode');
    this.route.navigate(['/' + url]);
  }

  generateUniqueCode() {
    const contactEmail = this.referenceForm.get('contactEmail')?.value;

    if (!contactEmail) return;
    this.fileService.generateCode(
      contactEmail,
      this.service.referenceFileDetails.referenceId,
      this.fileService.EMAIL_AUTH_APPLICATION_CODE
    ).subscribe(authCode => {
      this.authCode = authCode;
    });
  }
}
